import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { ExportSuspectedStudentsRankingUseCaseInterface } from 'domain/usecases';

export class RemoteExportSuspectedStudentsRanking
  implements ExportSuspectedStudentsRankingUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<ExportSuspectedStudentsRankingUseCaseInterface.Result>,
  ) {}

  async execute(
    params: ExportSuspectedStudentsRankingUseCaseInterface.Params,
  ): Promise<ExportSuspectedStudentsRankingUseCaseInterface.Result> {
    const { type, ...request } = params;

    const requestUrl = generateUrl(`${this.url}/${type}`, { ...request });

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
      responseType: 'json',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
